/* ═══════════════════════════════════════════════════════════════
   timmyT — slider.js
   Swiper fleet slider initialization
════════════════════════════════════════════════════════════════ */

'use strict';

document.addEventListener('DOMContentLoaded', () => {
  if (typeof Swiper === 'undefined') {
    console.warn('timmyT: Swiper.js not loaded — slider disabled.');
    return;
  }

  const fleetSwiper = new Swiper('.fleetSwiper', {
    // Core
    loop: true,
    speed: 700,
    grabCursor: true,

    // Effect
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },

    // Autoplay
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },

    // Pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: false,
    },

    // Navigation
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },

    // Keyboard
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },

    // Accessibility
    a11y: {
      prevSlideMessage: 'Vorheriges Bild',
      nextSlideMessage: 'Nächstes Bild',
    },
  });

  // Pause autoplay when slider is not in viewport
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          fleetSwiper.autoplay.start();
        } else {
          fleetSwiper.autoplay.stop();
        }
      });
    },
    { threshold: 0.3 }
  );

  const swiperEl = document.querySelector('.fleetSwiper');
  if (swiperEl) observer.observe(swiperEl);
});
